import React from 'react';
import PageTemplate from '../../components/PageTemplate';
const Ecommerce = () => {
  return <PageTemplate title="E-commerce Development" subtitle="Online Commerce Platforms" breadcrumb="Industries > E-commerce"><div className="content-section"><p>Custom e-commerce platforms, marketplaces, and online retail solutions.</p></div></PageTemplate>;
};
export default Ecommerce; 